// storeInstance.ts
import { getDefaultStore } from "jotai";
import { wrapperDimensionsAtom, recordingQualityAtom } from "./canvasStore";

export const store = getDefaultStore();

// Utility functions that use the store instance
export const getCanvasStoreValues = () => {
  return {
    wrapperDimensions: store.get(wrapperDimensionsAtom),
    recordingQuality: store.get(recordingQualityAtom),
  };
};
